import React from "react";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import Toggle from "../../../../Forms/Toggle";
import { Text } from "@fluentui/react";
import FluentSelect from "../../../../Forms/FluentSelect";
import ChoiceGroup from "../../../../Forms/ChoiceGroup";

const cobrandOptions = [
    { key: false, text: 'Off' },
    { key: true, text: 'On' },
];

const CobrandFields = ({ model }) => (
    <>
         <ChoiceGroup 
            label="Journal Cobrands On/Off Setting" 
            name="allCobrands" 
            options={cobrandOptions} 
            required
        />
        <Text variant="small">
            If the journal is {model.allCobrands ? "on" : "off"} to all cobrands, then you can
            set the exceptions below.
        </Text>
        <FluentSelect
            label={model.allCobrands ? "Hide From" : "Show To"}
            options={model.cobrands}
            isMulti
            name={model.allCobrands ? 'excludeCobrands' : 'includeCobrands'}
            menuPlacement="auto"
        />
    </>
);

export default CobrandFields;